import { render, staticRenderFns } from "./Soportes.vue?vue&type=template&id=c417734e&scoped=true"
import script from "./Soportes.vue?vue&type=script&lang=js"
export * from "./Soportes.vue?vue&type=script&lang=js"
import style0 from "./Soportes.vue?vue&type=style&index=0&id=c417734e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c417734e",
  null
  
)

export default component.exports